import { useTranslation } from 'next-i18next'
import UserIconConnected from 'assets/icons/nucleo/18px_user-cap.svg'
import { LinkButton } from 'components/LinkButton'

const UserAuthenticatedButton = () => {
  const { t } = useTranslation('authentication')
  return (
    <LinkButton
      prefetch={false}
      href="/account"
      passHref
      icon={<UserIconConnected />}
      aria-label={t('account.menu.profile.title')}
    />
  )
}

export default UserAuthenticatedButton
